<template>
    <ul class="mainmenu">
		<li><router-link to="/">首页</router-link></li>
        

        <li class="with-megamenu has-menu-child-item two-column-menu">
            <a href="#">
                元生AI与数据智能体平台
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <div style="height:3px; opacity:0.1"></div>
            <div class="rn-megamenu">
                <div class="wrapper">
                    <div class="row row--0">
                        <div class="col-lg-6 single-mega-item">
                            <ul class="mega-menu-item">
                                <li class="mega-menu-item-title"><router-link to="/dataAgent/1">博信诚AI元生平台</router-link></li>
                                <li><router-link to="/dataAgent/2">元生|DataAgent<span class="rn-badge-card-hot">Hot</span></router-link></li>
                                <li><router-link to="/dataAgent/3">AI审核<span class="rn-badge-card-hot">Hot</span></router-link></li>
                                <li><router-link to="/dataAgent/4">AI合同审核<span class="rn-badge-card-hot">Hot</span></router-link></li>
                                <li><router-link to="/dataAgent/5">AI智慧网银</router-link></li>
                                <li><router-link to="/dataAgent/6">AI报账</router-link></li>
                                <li><router-link to="">AI知识库</router-link></li>
                                <li><router-link to="">AI智能客服</router-link></li>
                                <li><router-link to="">AI智能体定制</router-link></li>
                            </ul>
                        </div>
                        <div class="col-lg-6 single-mega-item">
                            <ul class="mega-menu-item">
                                <li class="mega-menu-item-title"><router-link to="">数据智能体平台</router-link></li>
                                <li><router-link to="/eco-aibigdata">基于大模型的数据智能体平台<span class="rn-badge-card-new">New</span></router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="blueUS d-none d-lg-block">
                    <div class="Hotline">
                        <div class="left">
                            <div class="t1">
                                <img src="../../../assets/images/header_nav/phone-icon.png" alt="">咨询热线</div>
                            <div>周一 至 周五<br/>
                                09:00-18:00</div>
                        </div>
                        <div class="right">186 0092 4570<br/>186 0092 4570</div>
                    </div>
                    <div class="scanCode">
                        <div class="left">
                            <div class="t1">
                                <img src="../../../assets/images/header_nav/code-icon.png" alt="">扫码咨询</div>
                            <div>专业扫码获取<br/>专业咨询服务</div>
                        </div>
                        <div class="right code">
                            <img src="../../../assets/images/header_nav/code-code.png" alt="">
                        </div>
                    </div>
                    <div class="online">
                        <div class="left t1">
                            <img src="../../../assets/images/header_nav/online-icon.png" alt="">在线咨询</div>
                        <div class="right online-btn">咨询</div>
                    </div>
                </div>
            </div>
        </li>

        <li class="has-droupdown has-menu-child-item">
            <a href="#">
                智慧创新平台ECOP
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <ul class="submenu">
                <li><router-link to="/platform">智慧创新平台ECOP <span class="rn-badge-card-hot">Hot</span></router-link></li>
            </ul>
        </li>
        <li class="with-megamenu has-menu-child-item">
            <a href="#">
                云产品
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <div style="height:3px; opacity:0.1"></div>
            <div class="rn-megamenu">
                <div class="wrapper">
                    <div class="row row--0">
                        <div class="col-lg-4 single-mega-item">
                            <ul class="mega-menu-item">
                                <li class="mega-menu-item-title"><router-link to="">集团企业云EECLOUD</router-link></li>
                                <li><router-link to="/counter/1">智慧业财一体化云</router-link></li>
                                <li><router-link to="/counter/2">财务共享（中台）云 <span class="rn-badge-card-hot">Hot</span></router-link></li>
                                <li><router-link to="/counter/3">税务管理云</router-link></li>
                                <li><router-link to="/counter/4">全球司库管理云</router-link></li>
                                <li><router-link to="/counter/5">智慧网银云</router-link></li>
                                <li><router-link to="/counter/6">全面预算管理云</router-link></li>
                                <li><router-link to="/counter/7">智能分析云</router-link></li>
                            </ul>
                        </div>
                        <div class="col-lg-4 single-mega-item">
                            <ul class="mega-menu-item">
                                <li class="mega-menu-item-title"><router-link to="">成长型企业云ESCLOUD</router-link></li>
                                <li><router-link to="/portfolio/1">智能合同管理平台</router-link></li>
                                <li><router-link to="/portfolio/2">智慧业财管理平台</router-link></li>
                                <li><router-link to="/portfolio/3">智能决策与分析经营管理平台</router-link></li>
                                <li><router-link to="/portfolio/4">智能核算<span class="rn-badge-card-new">New</span></router-link></li>
                            </ul>
                        </div>
                        <div class="col-lg-4 single-mega-item">
                            <ul class="mega-menu-item">
								<li class="mega-menu-item-title"><router-link to="">智能技术RPA</router-link></li>
								<li><router-link to="/tab">智能技术RPA</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="blueUS d-none d-lg-block">
                    <div class="Hotline">
                        <div class="left">
                            <div class="t1">
                                <img src="../../../assets/images/header_nav/phone-icon.png" alt="">咨询热线</div>
                            <div>周一 至 周五<br/>
                                09:00-18:00</div>
                        </div>
                        <div class="right">186 0092 4570<br/>186 0092 4570</div>
                    </div>
                    <div class="scanCode">
                        <div class="left">
                            <div class="t1">
                                <img src="../../../assets/images/header_nav/code-icon.png" alt="">扫码咨询</div>
                            <div>专业扫码获取<br/>专业咨询服务</div>
                        </div>
                        <div class="right code">
                            <img src="../../../assets/images/header_nav/code-code.png" alt="">
                        </div>
                    </div>
                    <div class="online">
                        <div class="left t1">
                            <img src="../../../assets/images/header_nav/online-icon.png" alt="">在线咨询</div>
                        <div class="right online-btn">咨询</div>
                    </div>
                </div>
            </div>
        </li>
        <li class="with-megamenu has-menu-child-item">
            <a href="#">
                行业解决方案
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <div style="height:3px; opacity:0.1"></div>
            <div class="rn-megamenu">
                <div class="wrapper">
                    <div class="row row--0">
                        <div class="col-lg-4 single-mega-item">
                            <ul class="mega-menu-item">
                                <li class="mega-menu-item-title"><router-link to="/industry/1">制造行业<span class="rn-badge-card-hot">Hot</span></router-link></li>
                                <li><router-link to="/industry/1">机械制造</router-link></li>
                                <li><router-link to="/industry/1">高科技</router-link></li>
                                <li><router-link to="/industry/1">汽车</router-link></li>
                                <li><router-link to="/industry/1">航空与汽车</router-link></li>
                                <li><router-link to="/industry/1">水泥</router-link></li>
                                <!-- <li><router-link to="/blog-grid">全面预算管理云</router-link></li>
                                <li><router-link to="/blog-grid">智能分析云</router-link></li> -->
                            </ul>
                        </div>
                        <div class="col-lg-4 single-mega-item">
                            <ul class="mega-menu-item">
                                <li class="mega-menu-item-title"><router-link to="/industry/2">建筑与地产行业</router-link></li>
                                <li><router-link to="/industry/2">建筑施工</router-link></li>
                                <li><router-link to="/industry/2">房地产</router-link></li>
                                <li><router-link to="/industry/2">物业管理</router-link></li>
                                <!-- <li><router-link to="/tab">Tab</router-link></li>
                                <li><router-link to="/pricing">Pricing</router-link></li>
                                <li><router-link to="/spit-section">Split Section</router-link></li> -->
                            </ul>
                        </div>
                        <div class="col-lg-4 single-mega-item">
                            <ul class="mega-menu-item">
            					<li class="mega-menu-item-title"><router-link to="/industry/3">服务行业</router-link></li>
                                <li><router-link to="/industry/3">旅游</router-link></li>
                                <!-- <span class="rn-badge-card">Hot</span> -->
                                <li><router-link to="/industry/3">零售</router-link></li>
                                <!-- <span class="rn-badge-card">Comming</span> -->
                                <li><router-link to="/industry/3">餐饮</router-link></li>
                                <!-- <span class="rn-badge-card">Hot</span> -->
                                <li><router-link to="/industry/3">教育</router-link></li>
                                <!-- <li> <router-link to="/blog-details/1">Blog Details</router-link></li> -->
                            </ul>
                        </div>
                    </div>
            		<div class="row row--0">
            		    <div class="col-lg-4 single-mega-item">
            		        <ul class="mega-menu-item">
            		            <li class="mega-menu-item-title"><router-link to="/industry/4">公共服务行业</router-link></li>
            		            <li><router-link to="/industry/4">医院</router-link></li>
            		            <li><router-link to="/industry/4">政府及协会</router-link></li>
            		            <!-- <li><router-link to="/progressbar">税务管理云</router-link></li>
            		            <li><router-link to="/accordion">全球司库管理云</router-link></li>
            		            <li><router-link to="/social-share">智慧网银云</router-link></li>
            		            <li><router-link to="/blog-grid">全面预算管理云</router-link></li>
            		            <li><router-link to="/blog-grid">智能分析云</router-link></li> -->
            		        </ul>
            		    </div>
            		    <div class="col-lg-4 single-mega-item">
            		        <ul class="mega-menu-item">
            		            <li class="mega-menu-item-title"><router-link to="/industry/5">能源与矿业行业</router-link></li>
            		            <li><router-link to="/industry/5">石油天然气</router-link></li>
            		            <li><router-link to="/industry/5">化工</router-link></li>
            		            <li><router-link to="/industry/5">采矿</router-link></li>
            		            <!-- <li><router-link to="/tab">Tab</router-link></li>
            		            <li><router-link to="/pricing">Pricing</router-link></li>
            		            <li><router-link to="/spit-section">Split Section</router-link></li> -->
            		        </ul>
            		    </div>
            		    <div class="col-lg-4 single-mega-item">
            		        <ul class="mega-menu-item">
            					<li class="mega-menu-item-title"><router-link to="/industry/6">金融行业<span class="rn-badge-card-new">New</span></router-link></li>
            		            <li><router-link to="/industry/6">银行</router-link></li>
            		            <li><router-link to="/industry/6">保险</router-link></li>
            		            <li><router-link to="/industry/6">基金</router-link></li>
            		            <!-- <li><router-link to="/portfolio-details/1">Portfolio Details</router-link></li>
            		            <li><router-link to="/blog-details/1">Blog Details</router-link></li> -->
            		        </ul>
            		    </div>
            		</div>
                </div>
                <div class="blueUS d-none d-lg-block">
                    <div class="Hotline">
                        <div class="left">
                            <div class="t1">
                                <img src="../../../assets/images/header_nav/phone-icon.png" alt="">咨询热线</div>
                            <div>周一 至 周五<br/>
                                09:00-18:00</div>
                        </div>
                        <div class="right">186 0092 4570<br/>186 0092 4570</div>
                    </div>
                    <div class="scanCode">
                        <div class="left">
                            <div class="t1">
                                <img src="../../../assets/images/header_nav/code-icon.png" alt="">扫码咨询</div>
                            <div>专业扫码获取<br/>专业咨询服务</div>
                        </div>
                        <div class="right code">
                            <img src="../../../assets/images/header_nav/code-code.png" alt="">
                        </div>
                    </div>
                    <div class="online">
                        <div class="left t1">
                            <img src="../../../assets/images/header_nav/online-icon.png" alt="">在线咨询</div>
                        <div class="right online-btn">咨询</div>
                    </div>
                </div>
            </div>
        </li>
       
        <li class="has-droupdown has-menu-child-item">
            <a href="#">
                成功案例故事
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <ul class="submenu">
                <li class="mega-menu-item-title"><router-link to="/success-cases">成功案例 </router-link></li>
                <li class="mega-menu-item-title"><router-link to="/information">最新资讯 <span class="rn-badge-card-hot">Hot</span></router-link></li>
            </ul>
        </li>
        <li><router-link to="/service-support">服务与支持</router-link></li>
        <li class="has-droupdown has-menu-child-item">
            <a href="#">
                关于博信诚
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <ul class="submenu">
                <li class="mega-menu-item-title"><router-link to="/about-us">关于我们<span class="rn-badge-card-hot">Hot</span></router-link></li>
                <li class="mega-menu-item-title"><router-link to="/join-partners">加入生态伙伴</router-link></li>
                <li class="mega-menu-item-title"><router-link to="/call-us">联系我们</router-link></li>
            </ul>
        </li>
    </ul>
</template>

<script>
    import Icon from "../../icon/Icon";
    export default {
        name: 'Nav',
        components: {Icon}
    }
</script>